import { type FunctionalComponent, h} from '@stencil/core';
import { type LabelListElement, UiaasSearchLabelList } from '../../../result-cards/subcomponents/uiaas-search-label-list';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

export interface GenericCardLabels {
    labels?: LabelListElement[];
    labelProvider: labelProviderInterface;
    isLabelProviderOn?: boolean;
    hideTooltip?: boolean,
}

export const GenericCardLabels: FunctionalComponent<GenericCardLabels> = (props) => {

    const labels = [...props.labels];

    return <section class="result-card__label-panel">
      <UiaasSearchLabelList list={labels} isLabelProviderOn={props.isLabelProviderOn} labelProvider={props.labelProvider} hideTooltip={props.hideTooltip} />
    </section>;
};
